/**
 * 画布版本化展示标题：历史叶 / 临时投影 / 导航器共用，避免三套口径漂移。
 *
 * 展示口径对齐引用列表：`base（V{n}）`（全角括号）。
 * 输入框 mention 仍用无括号 `V{n}`，不在此模块处理。
 */

export function formatCanvasVersionedDisplayTitle(
  baseName: string,
  versionSeq: number | null | undefined
): string {
  const base = baseName.trim();
  if (!base) return '';
  if (typeof versionSeq === 'number' && versionSeq > 0) {
    return `${base}（V${versionSeq}）`;
  }
  return base;
}

/**
 * 从冻结展示名拆 base + seq。
 *
 * 支持：
 * - `名（V1）`（历史叶 / 列表面板）
 * - `名V1`（mention 内部名）
 * - `名-01`（资产生成名 element-tag-{seq:02d}）
 *
 * 无版本后缀时不瞎拆；单数字 `-1` 不认作版本，避免误伤。
 */
export function splitCanvasDisplayNameAndVersion(displayName: string): {
  baseName: string;
  versionSeq: number | null;
} {
  const value = displayName.trim();
  if (!value) {
    return { baseName: '', versionSeq: null };
  }

  const fullWidth = value.match(/^(.*)（V(\d+)）$/);
  if (fullWidth?.[1] !== undefined) {
    const seq = Number(fullWidth[2]);
    return {
      baseName: fullWidth[1].trim(),
      versionSeq: seq > 0 ? seq : null,
    };
  }

  const bare = value.match(/^(.*)V(\d+)$/);
  if (bare?.[1] !== undefined) {
    const seq = Number(bare[2]);
    return {
      baseName: bare[1].trim(),
      versionSeq: seq > 0 ? seq : null,
    };
  }

  // 资产冻结名：`卡洛斯-e2e2-01`（后端 `_build_element_plan_name` 用 :02d）
  const padded = value.match(/^(.*)-(\d{2,})$/);
  if (padded?.[1] !== undefined) {
    const seq = Number(padded[2]);
    if (seq > 0) {
      return {
        baseName: padded[1].trim(),
        versionSeq: seq,
      };
    }
  }

  return { baseName: value, versionSeq: null };
}
